import React from 'react';

const JhLogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="30"
    viewBox="0 0 44 45"
  >
    <defs>
      <path id="a" d="M.563.335h44v44.148h-44z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1)">
        <path
          fill="#ffffff"
          d="M21.51 40.314c.432.036.866.048 1.302.048.611 0 1.218-.023 1.815-.084l3.315-9.494h-3.218l-3.214 9.53zm9.364-1.914c5.724-2.977 9.64-9.02 9.64-15.994 0-8.778-6.22-16.092-14.423-17.653l-6.303 17.863s-1.63 5.838-8.068 4.61c-7.605-1.465-2.904-10.135-2.904-10.135h5.028s-.932 2.416-1.261 3.61c-.4 1.421 1.562 1.896 2.07.482.516-1.419 5.727-16.568 5.727-16.568C11.755 5.82 5.113 13.327 5.113 22.406c0 7.53 4.575 13.978 11.044 16.645l7.749-22.157h5.657l-2.82 8.372h3.019l3.018-8.372h5.635L30.875 38.4zM1.06 22.406C1.06 10.22 10.803.335 22.812.335c12.02 0 21.751 9.884 21.751 22.071 0 12.194-9.73 22.077-21.751 22.077-12.009 0-21.752-9.883-21.752-22.077z"
          mask="url(#b)"
        />
      </g>
      <path
        fill="#ffffff"
        d="M42.527 4V1.495h-.014L41.574 4h-.299l-.938-2.505h-.014V4h-.473V1h.73l.855 2.279L42.277 1H43v3h-.473zM38.37 1.4V4h-.473V1.4H37V1h2.266v.4h-.896z"
      />
    </g>
  </svg>
);

export default JhLogoIcon;
